import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import 'react-phone-input-2/lib/material.css'
import { Grid, MenuItem, FormControl, InputLabel, Select } from '@material-ui/core'

import { fetaures } from '~/constants/data-field'
import { useGrowCropsStore } from '~/store/variety/growcrops'

import { useStyles } from './style'

export const LesionNematodeForms: React.FC = () => {
  const classes = useStyles()

  const { control } = useFormContext<any>()
  const featuresList = useGrowCropsStore((state) => state.featuresList)

  const arrayFeatures = featuresList.filter(
    (item) => item?.caracteristica !== 'CISTO' && item?.tipo !== 'DOENCAS',
  )

  return (
    <Grid container spacing={3} className={classes.modalStyle}>
      {arrayFeatures?.map((item) => (
        <Grid item sm={12} key={item.id}>
          <Controller
            name={item.nome_cientifico.replace(/\s/g, '').toLowerCase()}
            control={control}
            render={({ field }) => (
              <FormControl variant="outlined" className={classes.selectInput}>
                <InputLabel id={`${item.nome_cientifico.replace(/\s/g, '')}_id`}>
                  {item.nome_cientifico}
                </InputLabel>
                <Select
                  {...field}
                  labelId={`${item.nome_cientifico.replace(/\s/g, '')}_id`}
                  id={item.nome_cientifico.replace(/\s/g, '').toLowerCase()}
                  label={item.nome_cientifico}
                  autoWidth
                  required
                  defaultValue=""
                >
                  {fetaures.map((Option) => (
                    <MenuItem key={Option.fetauresValue} value={Option.fetauresValue}>
                      {Option.fetauresName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          />
        </Grid>
      ))}
    </Grid>
  )
}
